export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4RolloutAnalytics';
export const TEAM_NAME = 'jira-cosmos';
